import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { HomeHero } from '@/components/landing/home-hero'
import { LogoMarquee } from '@/components/landing/logo-marquee'
import { FullServiceSection } from '@/components/landing/full-service-section'
import { TestimonialsSlider } from '@/components/landing/testimonials-slider'
import { NumbersSection } from '@/components/landing/numbers-section'
import { CtaSection } from '@/components/landing/cta-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout launcher>
            <Seo />

            <HomeHero />

            <LogoMarquee />

            <div className='pt-16 md:pt-24'>
                <FullServiceSection />
            </div>

            <TestimonialsSlider />

            <NumbersSection />

            <CtaSection
                title='Ready to connect everything?'
                accent="Let's talk."
                actions={[
                    { label: 'Contact us', variant: 'primary', intent: 'contact' },
                    { label: 'About FlowCraft', variant: 'secondary', href: '/full-service#story' }
                ]}
            />
        </Layout>
    )
}

export default Home
